var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_778_1707)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.4882 15.5H3.5127C3.05451 15.5 2.62629 15.3143 2.33724 14.9913C2.04605 14.6625 1.93471 14.2369 2.03749 13.823C2.64984 11.3182 5.15707 9.5 8.00045 9.5C10.8438 9.5 13.3511 11.3182 13.9634 13.823C14.064 14.2369 13.9548 14.6625 13.6637 14.9913C13.3767 15.3143 12.9485 15.5 12.4882 15.5ZM8.00045 10.4671C5.65594 10.4671 3.58764 11.9662 3.08234 14.0319C3.05237 14.1576 3.08234 14.2872 3.17227 14.3859C3.22151 14.44 3.33071 14.5329 3.5127 14.5329H12.4882C12.6702 14.5329 12.7794 14.44 12.8286 14.3859C12.9164 14.2872 12.9485 14.1576 12.9186 14.0319C12.4133 11.9662 10.345 10.4671 8.00045 10.4671Z",
    fill: "#4E7E6E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 8.49783C5.79445 8.49783 4 6.70337 4 4.49782C4 2.29228 5.79445 0.5 8 0.5C10.2055 0.5 12 2.29445 12 4.5C12 6.70555 10.2055 8.5 8 8.5V8.49783ZM8 1.58755C6.39478 1.58755 5.08755 2.8926 5.08755 4.5C5.08755 6.1074 6.3926 7.41245 8 7.41245C9.6074 7.41245 10.9125 6.1074 10.9125 4.5C10.9125 2.8926 9.6074 1.58755 8 1.58755Z",
    fill: "#4E7E6E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_778_1707"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.52eb92b84977b165793b0202f72f29be.svg";
export { ForwardRef as ReactComponent };